import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { GetRoadHome } from './components/newHome/GetRoadHome';
import NewLicenseJoruney from './components/newHome/NewLicenseJoruney';
import FlexibleNew from './components/newHome/FlexibleNew';
import { GuideTestimonials } from './components/newpages/guide/GuideTestimonials';
import GuideBanner from './components/newpages/guide/Forward';
import EmbarkBanner from './components/newpages/embark/EmbarkBanner';
import Mind from './components/newpages/conquer/Mind';
import QuickLinks from './components/newHome/QuickLinks';
import Help from './components/help/Help';
import { Contact } from './components/contactus/Contact';
import { FaqCsOne } from './components/faqcsone/FaqCsOne';
import BgImageWithLeftText from './components/newpages/dynamicSections/BgImageWithLeftText';
import BgImageWithCenterText from './components/newpages/dynamicSections/BgImageWithCenterText';
import BgImageWithRightText from './components/newpages/dynamicSections/BgImageWithRightText';

const DynamicPage = ({ dynamicPages }) => {
  const location = useLocation();
  const currentURL = location.pathname;

  // Move capitalizeWords function above its usage
  const capitalizeWords = (str) => 
    str.split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  const cleanedPath = (currentURL === '/xcsfvt' || currentURL === '/xcsfvt/') 
    ? 'Home' 
    : capitalizeWords(currentURL.split('/').filter(Boolean).pop().replace(/-/g, ' '));

  const [sections, setSections] = useState([]);

  useEffect(() => {
    if (dynamicPages) {
      const sectionsArray = dynamicPages.flatMap(page => {
        if (capitalizeWords(page.name) === cleanedPath) {
          return page.sections.map(e => ({
            id: e.id,
            keyName: e.key_name || '',
            heading: e.heading,
            contents: e.page_section_contents
          }));
        }
        return []; // Return an empty array if no match
      });
      setSections(sectionsArray);
    }
  }, [dynamicPages, cleanedPath]);

  const renderSection = (section) => {
    const { keyName, id, heading, contents } = section;

    const sectionComponents = {
      'banner-with-search': <GetRoadHome key={id} heading={heading} content={contents} />,
      'card-with-icons': <NewLicenseJoruney key={id} heading={heading} cardContent={contents} />,
      'card-with-border': <FlexibleNew key={id} heading={heading} content={contents} />,
      'card-with-background': <QuickLinks key={id} heading={heading} cardContent={contents} />,
      'card-without-icons': <FaqCsOne key={id} heading={heading} content={contents} />,
      'slider': <GuideTestimonials key={id} heading={heading} content={contents} />,
      'background-color-with-left-text': <GuideBanner key={id} heading={heading} cardContent={contents} />,
      'banner-with-text': <EmbarkBanner key={id} heading={heading} content={contents} />,
      'full-background-text': <Contact key={id} content={contents} />,
      'background-image-with-left-text': <BgImageWithLeftText key={id} heading={heading} content={contents} />,
      'background-image-with-right-text': <BgImageWithRightText key={id} heading={heading} content={contents} />,
      'background-image-with-center-text': <BgImageWithCenterText key={id} heading={heading} content={contents} />,
      'full-content-without-background': <Mind key={id} heading={heading} content={contents} />,
      'image-with-left-text': <Help key={id} heading={heading} content={contents} />,
    };

    return sectionComponents[keyName] || null;
  };

  return (
    <div>
      {sections.sort((a, b) => a.id - b.id).map(section => renderSection(section))}
    </div>
  );
};

export default DynamicPage;
